import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  httpDelete,
  httpGet,
  httpPost,
  httpPut,
} from "../../services/httpService";
import {
  getTemplatesUrl,
  saveTemplateUrl,
  getEmailsAndSmsTemplatesUrl,
  addEmailsAndSmsTemplatesUrl,
  updateEmailsAndSmsTemplatesUrl,
  getDefaultTemplatesUrl,
  deleteEmailsAndSmsTemplatesUrl,
  generatePatientPrescriptionUrl,
  saveAiTemplateUrl,
  generateAiTemplateUrl,
  updateAiTemplateUrl,
  getAiTemplateByCompanyIdUrl,
  getAiTemplateByIdUrl,
  sendAIQAURL,
  deleteAiTemplateByIdUrl,
  getPreConsultTemplateByCompanyIdUrl,
  savePreConsultTemplateUrl,
  updatePreConsultTemplateUrl,
  deletePreConsultTemplateByIdUrl,
  generatePreConsultAiTemplateUrl,
  getDefaultMessageTemplateUrl,
} from "../../apiUrls/apiUrls";
import { logErrorWithPayload } from "@/services/logService";

const initialState = {
  isConsultationLoading: false,
  isTemplatesLoading: false,
  currentTemplates: [],
  isDropdownAiTemplatesLoading: false,
  currentAiTemplates: [],
  currentTemplate: null,
  emailsAndSmsTemplates: [],
  templateMessageType: 0,
  updateMessagetemplateData: null,
  defaultTemplates: null,
  emailSubject: "",
  aiTemplate: [],
  saveAiTemplate: [],
  isAiTemplateLoading: false,
  isSaveAiTemplateLoading: false,
  isSelectedAiTemplateLoading: false,
  selectedTemplate: [],
  selectedTemplateData: [],
  aiqaData: [],
  expandedSection: null,
  fullTranscript: null,
  consultationInitiatedOn: null,
  hydratedTemplateSections: null,
  isTemplateSelected: false,
  isAIQALoading: false,
  isAiTemplateDeleteByIdLoading: false,
  streamedText: "",
  savePreConsultTemplate: [],
  isSavePreConsultTemplateLoading: false,
  updatePreConsultTemplate: [],
  isUpdatePreConsultTemplateLoading: false,
  isPreConsultTemplatesLoading: false,
  currentPreConsultTemplates: [],
  isPreConsultAiTemplateLoading: false,
  preConsultAiTemplate: [],
  isConsultationSummaryLoading: false,
  consultationStreamedSummary: "",
  defaultCompanyMessageTemplates: [],
  isDefaultMessageTemplateLoading: false,
  transcriptionState: "idle",
};

export const getTemplatesData = createAsyncThunk(
  "template/getTemplatesData",
  async (companyId, thunkAPI) => {
    const urlToGet = getTemplatesUrl(companyId);
    const respData = await httpGet(urlToGet);
    return respData;
  },
);
export const getAiTemplateByCompanyIdData = createAsyncThunk(
  "template/getAiTemplateByCompanyIdData",
  async (companyId, thunkAPI) => {
    const urlToGet = getAiTemplateByCompanyIdUrl(companyId);
    const respData = await httpGet(urlToGet);
    return respData;
  },
);

export const getEmailsAndSmsTemplatesData = createAsyncThunk(
  "template/getEmailsAndSmsTemplatesData",
  async (companyId, thunkAPI) => {
    const urlToGet = getEmailsAndSmsTemplatesUrl(companyId);
    const respData = await httpGet(urlToGet);
    return respData;
  },
);

export const addTemplateData = createAsyncThunk(
  "template/addTemplateData",
  async (data, thunkAPI) => {
    const respData = await httpPost(saveTemplateUrl(), data);
    return respData;
  },
);

export const addEmailsAndSmsTemplatesData = createAsyncThunk(
  "template/addEmailsAndSmsTemplatesData",
  async (data, thunkAPI) => {
    try {
      const respData = await httpPost(addEmailsAndSmsTemplatesUrl(), data);
      return respData;
    } catch (error) {
      if (error?.response?.status === 409 || error?.status === 409) {
        return thunkAPI.rejectWithValue({
          status: 409,
          code: "DUPLICATE_TEMPLATE_NAME",
        });
      }
      throw error;
    }
  },
);

export const updateEmailsAndSmsTemplatesData = createAsyncThunk(
  "template/updateEmailsAndSmsTemplatesData",
  async (data, thunkAPI) => {
    const respData = await httpPut(updateEmailsAndSmsTemplatesUrl(), data);
    return respData;
  },
);

export const getDefaultTemplatesData = createAsyncThunk(
  "template/getDefaultTemplatesData",
  async (actionType, thunkAPI) => {
    const urlToGet = getDefaultTemplatesUrl(actionType);
    const respData = await httpGet(urlToGet);
    return respData;
  },
);

export const deleteEmailsAndSmsTemplatesData = createAsyncThunk(
  "template/deleteEmailsAndSmsTemplates",
  async (data, thunkAPI) => {
    const urlToDelete = deleteEmailsAndSmsTemplatesUrl();
    const respData = await httpPost(urlToDelete, data);
    return respData;
  },
);

export const generatePatientPrescriptionData = createAsyncThunk(
  "template/generatePatientPrescriptionData",
  async (data, thunkAPI) => {
    const respData = await httpPost(generatePatientPrescriptionUrl(), data);
    return respData;
  },
);
export const generateAiTemplateData = createAsyncThunk(
  "template/generateAiTemplateData",
  async (data, thunkApi) => {
    const respData = await httpPost(generateAiTemplateUrl(), data);
    return respData;
  },
);
export const saveAiTemplateData = createAsyncThunk(
  "template/saveAiTemplateData",
  async (params, thunkAPI) => {
    const respData = await httpPost(saveAiTemplateUrl(), params);
    return respData;
  },
);
export const updateAiTemplatesData = createAsyncThunk(
  "template/updateAiTemplatesData",
  async (data, thunkAPI) => {
    const respData = await httpPost(updateAiTemplateUrl(), data);
    return respData;
  },
);

export const getAiTemplateByIdData = createAsyncThunk(
  "template/getAiTemplateByIdData",
  async (templateId, thunkAPI) => {
    const urlToGet = getAiTemplateByIdUrl(templateId);
    const respData = await httpGet(urlToGet);
    return respData;
  },
);

export const sendAiConsultationData = createAsyncThunk(
  "template/ai/qa",
  async (params, thunkAPI) => {
    const { data } = params || {};
    const respData = await httpPost(sendAIQAURL(), data);
    return respData;
  },
);

export const deleteAiTemplateByIdData = createAsyncThunk(
  "template/deleteAiTemplateByIdData",
  async (templateID) => {
    const respData = await httpDelete(deleteAiTemplateByIdUrl(templateID));
    return respData;
  },
);
export const getPreConsultTemplateByCompanyIdData = createAsyncThunk(
  "template/getPreConsultTemplateByCompanyIdData",
  async (companyId, thunkAPI) => {
    const urlToGet = getPreConsultTemplateByCompanyIdUrl(companyId);
    const respData = await httpGet(urlToGet);
    return respData;
  },
);
export const savePreConsultTemplateData = createAsyncThunk(
  "template/savePreConsultTemplateData",
  async (params, thunkAPI) => {
    const respData = await httpPost(savePreConsultTemplateUrl(), params);
    return respData;
  },
);
export const updatePreConsultTemplatesData = createAsyncThunk(
  "template/updatePreConsultTemplatesData",
  async (data, thunkAPI) => {
    const respData = await httpPost(updatePreConsultTemplateUrl(), data);
    return respData;
  },
);
export const deletePreConsultTemplateByIdData = createAsyncThunk(
  "template/deletePreConsultTemplateByIdData",
  async (templateID) => {
    const respData = await httpDelete(
      deletePreConsultTemplateByIdUrl(templateID),
    );
    return respData;
  },
);
export const generatePreConsultAiTemplateData = createAsyncThunk(
  "template/generatePreConsultAiTemplateData",
  async (data, thunkApi) => {
    const respData = await httpPost(generatePreConsultAiTemplateUrl(), data);
    return respData;
  },
);
export const getDefaultMessageTemplateData = createAsyncThunk(
  "template/getDefaultMessageTemplateData",
  async (companyId, thunkAPI) => {
    const urlToGet = getDefaultMessageTemplateUrl(companyId);
    const respData = await httpGet(urlToGet);
    return respData;
  },
);
export const templateSlice = createSlice({
  name: "template",
  initialState,
  reducers: {
    setIsConsultationLoading: (state, action) => {
      state.isConsultationLoading = action?.payload || false;
    },
    setIsTemplatesLoading: (state, action) => {
      state.isTemplatesLoading = action?.payload || false;
    },
    setTemplatesData: (state, action) => {
      state.currentTemplates = action?.payload || [];
    },
    setTemplateMessageTypeData: (state, action) => {
      state.templateMessageType = action?.payload || 0;
    },
    setUpdateMessagetemplateData: (state, action) => {
      state.updateMessagetemplateData = action?.payload || null;
    },
    setEmailSubjectData: (state, action) => {
      state.emailSubject = action?.payload || "";
    },
    setAitemplateData: (state, action) => {
      state.aiTemplate = action?.payload || "";
    },
    setSelectedTemplateData: (state, action) => {
      state.selectedTemplate = action?.payload || "";
    },
    setSelectedTemplateContentData: (state, action) => {
      state.selectedTemplateData = action?.payload || "";
    },
    setAiqaData: (state, action) => {
      state.aiqaData = action?.payload || false;
    },

    setFullTranscriptData: (state, action) => {
      state.fullTranscript = action?.payload || null;
    },
    setConsultationInitiatedOnData: (state, action) => {
      state.consultationInitiatedOn = action?.payload || null;
    },
    setHydratedTemplateSectionsData: (state, action) => {
      state.hydratedTemplateSections = action?.payload || null;
    },
    setIsTemplateSelectedData: (state, action) => {
      state.isTemplateSelected = action?.payload || false;
    },
    setIsAIQALoadingData: (state, action) => {
      state.isAIQALoading = action?.payload || false;
    },
    setStreamedTextData: (state, action) => {
      state.streamedText = action?.payload || "";
    },
    setIsConsultationSummaryLoadingData: (state, action) => {
      state.isConsultationSummaryLoading = action?.payload || false;
    },
    setConsultationStreamedSummaryData: (state, action) => {
      state.consultationStreamedSummary = action?.payload || false;
    },
    setTranscriptionStateData: (state, action) => {
      state.transcriptionState =
        action?.payload !== undefined ? action.payload : "idle";
    },

    resetConsultationState: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getTemplatesData.pending, (state) => {
        state.isConsultationLoading = true;
      })
      .addCase(getTemplatesData.fulfilled, (state, action) => {
        state.isConsultationLoading = false;
        state.currentTemplates = action?.payload || [];
      })
      .addCase(getTemplatesData.rejected, (state, action) => {
        state.isConsultationLoading = false;
        state.currentTemplates = [];
      })
      .addCase(getAiTemplateByCompanyIdData.pending, (state) => {
        state.isDropdownAiTemplatesLoading = true;
      })
      .addCase(getAiTemplateByCompanyIdData.fulfilled, (state, action) => {
        state.isConsultationLoading = false;
        state.isDropdownAiTemplatesLoading = false;
        state.currentAiTemplates = action?.payload || [];
      })
      .addCase(getAiTemplateByCompanyIdData.rejected, (state, action) => {
        state.isConsultationLoading = false;
        state.isDropdownAiTemplatesLoading = false;
        state.currentAiTemplates = [];
      })

      .addCase(addTemplateData.pending, (state) => {
        state.isConsultationLoading = true;
      })
      .addCase(addTemplateData.fulfilled, (state, action) => {
        state.isConsultationLoading = false;
        state.currentTemplate = action?.payload;
      })
      .addCase(addTemplateData.rejected, (state, action) => {
        logErrorWithPayload(action?.error);
        state.isConsultationLoading = false;
        state.currentTemplate = null;
      })

      .addCase(getEmailsAndSmsTemplatesData.pending, (state) => {
        state.isTemplatesLoading = true;
      })
      .addCase(getEmailsAndSmsTemplatesData.fulfilled, (state, action) => {
        state.isTemplatesLoading = false;
        state.emailsAndSmsTemplates = action?.payload || [];
      })
      .addCase(getEmailsAndSmsTemplatesData.rejected, (state, action) => {
        state.isTemplatesLoading = false;
        state.emailsAndSmsTemplates = [];
      })

      .addCase(addEmailsAndSmsTemplatesData.pending, (state) => {
        state.isTemplatesLoading = true;
      })
      .addCase(addEmailsAndSmsTemplatesData.fulfilled, (state, action) => {
        state.isTemplatesLoading = false;
      })
      .addCase(addEmailsAndSmsTemplatesData.rejected, (state, action) => {
        state.isTemplatesLoading = false;
      })

      .addCase(updateEmailsAndSmsTemplatesData.pending, (state) => {
        state.isTemplatesLoading = true;
      })
      .addCase(updateEmailsAndSmsTemplatesData.fulfilled, (state, action) => {
        state.isTemplatesLoading = false;
      })
      .addCase(updateEmailsAndSmsTemplatesData.rejected, (state, action) => {
        state.isTemplatesLoading = false;
      })
      .addCase(getDefaultTemplatesData.pending, (state) => {
        state.isTemplatesLoading = true;
      })
      .addCase(getDefaultTemplatesData.fulfilled, (state, action) => {
        state.isTemplatesLoading = false;
        state.defaultTemplates = action?.payload || null;
      })
      .addCase(getDefaultTemplatesData.rejected, (state, action) => {
        state.isTemplatesLoading = false;
      })
      .addCase(deleteEmailsAndSmsTemplatesData.pending, (state, action) => {
        state.isTemplatesLoading = true;
      })
      .addCase(deleteEmailsAndSmsTemplatesData.fulfilled, (state, action) => {
        const ids = action.meta.arg;
        if (action.payload) {
          state.emailsAndSmsTemplates = state.emailsAndSmsTemplates.filter(
            (template) => !ids.includes(template._id),
          );
        } else {
          console.error(
            "Failed to delete templates:",
            action.payload.message || "Unknown error",
          );
          state.error = action.payload.message || "Failed to delete templates";
        }

        state.isTemplatesLoading = false;
      })
      .addCase(deleteEmailsAndSmsTemplatesData.rejected, (state, action) => {
        state.isTemplatesLoading = false;
      })
      .addCase(generatePatientPrescriptionData.pending, (state) => {
        state.isTemplatesLoading = true;
      })
      .addCase(generatePatientPrescriptionData.fulfilled, (state, action) => {
        state.isTemplatesLoading = false;
      })
      .addCase(generatePatientPrescriptionData.rejected, (state, action) => {
        state.isTemplatesLoading = false;
      })
      .addCase(generateAiTemplateData.pending, (state) => {
        state.isAiTemplateLoading = true;
      })
      .addCase(generateAiTemplateData.fulfilled, (state, action) => {
        state.isAiTemplateLoading = false;
        state.aiTemplate = action?.payload;
      })
      .addCase(generateAiTemplateData.rejected, (state, action) => {
        logErrorWithPayload(action?.error);
        state.isAiTemplateLoading = false;
      })
      .addCase(saveAiTemplateData.pending, (state) => {
        state.isSaveAiTemplateLoading = true;
      })
      .addCase(saveAiTemplateData.fulfilled, (state, action) => {
        state.isSaveAiTemplateLoading = false;
        state.saveAiTemplate = action?.payload;
      })
      .addCase(saveAiTemplateData.rejected, (state, action) => {
        logErrorWithPayload(action?.error);
        state.isSaveAiTemplateLoading = false;
        state.changeCompany = null;
      })
      .addCase(updateAiTemplatesData.pending, (state) => {
        state.isAiTemplateLoading = true;
      })
      .addCase(updateAiTemplatesData.fulfilled, (state, action) => {
        state.isAiTemplateLoading = false;
      })
      .addCase(updateAiTemplatesData.rejected, (state, action) => {
        state.isAiTemplateLoading = false;
      })
      .addCase(getAiTemplateByIdData.pending, (state) => {
        state.isSelectedAiTemplateLoading = true;
      })
      .addCase(deleteAiTemplateByIdData.pending, (state) => {
        state.isAiTemplateDeleteByIdLoading = true;
      })
      .addCase(deleteAiTemplateByIdData.fulfilled, (state) => {
        state.isAiTemplateDeleteByIdLoading = false;
      })
      .addCase(getAiTemplateByIdData.fulfilled, (state, action) => {
        state.isSelectedAiTemplateLoading = false;
        state.selectedTemplateData = action?.payload;
      })
      .addCase(getAiTemplateByIdData.rejected, (state, action) => {
        state.isSelectedAiTemplateLoading = false;
      })
      .addCase(sendAiConsultationData.pending, (state) => {
        state.isAIQALoading = true;
      })
      .addCase(sendAiConsultationData.fulfilled, (state, action) => {
        const dataFromResponse = action?.payload;
        if (dataFromResponse) {
          try {
            state.aiqaData = JSON.parse(dataFromResponse) || [];
            state.isAIQALoading = false;
          } catch (error) {}
        }
      })
      .addCase(sendAiConsultationData.rejected, (state, action) => {
        state.aiqaData = [];
        state.isAIQALoading = true;
      })

      .addCase(updatePreConsultTemplatesData.pending, (state) => {
        state.isUpdatePreConsultTemplateLoading = true;
      })
      .addCase(updatePreConsultTemplatesData.fulfilled, (state, action) => {
        state.isUpdatePreConsultTemplateLoading = false;
        state.updatePreConsultTemplate = action?.payload;
      })
      .addCase(updatePreConsultTemplatesData.rejected, (state, action) => {
        logErrorWithPayload(action?.error);
        state.isUpdatePreConsultTemplateLoading = false;
        state.updatePreConsultTemplate = null;
      })
      .addCase(getPreConsultTemplateByCompanyIdData.pending, (state) => {
        state.isPreConsultTemplatesLoading = true;
      })
      .addCase(
        getPreConsultTemplateByCompanyIdData.fulfilled,
        (state, action) => {
          state.isPreConsultTemplatesLoading = false;
          state.currentPreConsultTemplates = action?.payload || [];
        },
      )
      .addCase(
        getPreConsultTemplateByCompanyIdData.rejected,
        (state, action) => {
          state.isPreConsultTemplatesLoading = false;
          state.currentPreConsultTemplates = [];
        },
      )
      .addCase(deletePreConsultTemplateByIdData.pending, (state) => {
        state.isPreConsultTemplatesLoading = true;
      })
      .addCase(deletePreConsultTemplateByIdData.fulfilled, (state) => {
        state.isPreConsultTemplatesLoading = false;
      })
      .addCase(deletePreConsultTemplateByIdData.rejected, (state) => {
        state.isPreConsultTemplatesLoading = false;
      })
      .addCase(generatePreConsultAiTemplateData.pending, (state) => {
        state.isPreConsultAiTemplateLoading = true;
      })
      .addCase(generatePreConsultAiTemplateData.fulfilled, (state, action) => {
        state.isPreConsultAiTemplateLoading = false;
        state.preConsultAiTemplate = action?.payload;
      })
      .addCase(generatePreConsultAiTemplateData.rejected, (state, action) => {
        logErrorWithPayload(action?.error);
        state.isPreConsultAiTemplateLoading = false;
      })
      .addCase(savePreConsultTemplateData.pending, (state) => {
        state.isSavePreConsultTemplateLoading = true;
      })
      .addCase(savePreConsultTemplateData.fulfilled, (state, action) => {
        state.isSavePreConsultTemplateLoading = false;
        state.savePreConsultTemplate = action?.payload;
      })
      .addCase(savePreConsultTemplateData.rejected, (state, action) => {
        logErrorWithPayload(action?.error);
        state.isSavePreConsultTemplateLoading = false;
        state.savePreConsultTemplate = null;
      })
      .addCase(getDefaultMessageTemplateData.pending, (state) => {
        state.isDefaultMessageTemplateLoading = true;
      })
      .addCase(getDefaultMessageTemplateData.fulfilled, (state, action) => {
        state.isDefaultMessageTemplateLoading = false;
        state.defaultCompanyMessageTemplates = action?.payload;
      })
      .addCase(getDefaultMessageTemplateData.rejected, (state, action) => {
        logErrorWithPayload(action?.error);
        state.isDefaultMessageTemplateLoading = false;
        state.defaultCompanyMessageTemplates = null;
      });
  },
});

// Action creators are generated for each case reducer function
export const {
  setIsConsultationLoading,
  setIsTemplatesLoading,
  setTemplatesData,
  resetConsultationState,
  setTemplateMessageTypeData,
  setUpdateMessagetemplateData,
  setEmailSubjectData,
  setAitemplateData,
  setSelectedTemplateData,
  setSelectedTemplateContentData,
  setAiqaData,
  setFullTranscriptData,
  setConsultationInitiatedOnData,
  setHydratedTemplateSectionsData,
  setIsTemplateSelectedData,
  setIsAIQALoadingData,
  isAiTemplateDeleteLoading,
  setStreamedTextData,
  setIsConsultationSummaryLoadingData,
  setConsultationStreamedSummaryData,
  setTranscriptionStateData,
} = templateSlice.actions;

export default templateSlice.reducer;
